<script>
	const model = require('model/model');
	const utilities = require('utilities');
	const routeContext = require('core/routeContext');

	module.exports = {
		methods: {
			closeModal() {
				model.set('workspacePreviewModalAssignment', routeContext.getParam('aid'));
				utilities.closeModals();
			},
			onDismiss() {
				model.set('workspacePreviewModalDismiss', true);
				utilities.closeModals();
			}
		}
	};
</script>
<template>
	<modal
		id="modal-workspace-preview"
		:closeable="false"
		:no-auto-close="true">
		<div slot="content">
			<h3>Note to Teacher</h3>
			<p>In this Student View, your highlights and annotations will not be saved, and you cannot answer questions.</p>
			<p>For students, all work will be saved as expected.</p>
			<div class="text-centered margin-top-large">
				<button
					class="button"
					@click="closeModal">
					Acknowledge
				</button>
				<div
					class="font-small link text-muted margin-top-medium"
					@click="onDismiss">
					Don't show this message again.
				</div>
			</div>
		</div>
	</modal>
</template>
